// El Cielo Alpha y el Jefe Final.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Alpha Journey (El Cielo Alpha) ----

export const cmsGenerateJourney = async (courseId, force = false) =>
  (await api.post(`/cms/courses/${courseId}/journey/generate?force=${force}`)).data;
export const cmsGetJourney = async (mapId) => (await api.get(`/cms/journeys/${mapId}`)).data;
export const cmsUpdateJourney = async (mapId, payload) => (await api.patch(`/cms/journeys/${mapId}`, payload)).data;
export const getJourney = async (courseId) => (await api.get(`/journey/course/${courseId}`)).data;
export const completeJourneyNode = async (mapId, nodeId) =>
  (await api.post(`/journey/${mapId}/complete`, { node_id: nodeId })).data;
/** El cobro del Recorrido: las luces de un tramo, una vez, en Esencia. Las reglas —y por qué
 *  una cifra que dice el navegador no es una fuga— están en `backend/app/domain/reguero.py`. */
export const cobraElRecorrido = async (mapId, nodeId, luces, de) =>
  (await api.post(`/journey/${mapId}/recorrido`, { node_id: nodeId, luces, de })).data;
export const getJourneyEchoes = (courseId) =>
  api.get(`/journey/course/${courseId}/echoes`).then((r) => r.data.echoes);
export const getGalaxy = async () => (await api.get("/journey/galaxy")).data;

// ---- Jefe Final (Final Boss) ----

// El Jefe es por modulo: `modulo` va en la consulta, y sin el es el del curso entero.
// `prueba` solo la atiende el servidor a un administrador (ruta /finalboss).
export const getBoss = (courseId, modulo, prueba = false) =>
  api.get(`/boss/${courseId}`, { params: { ...(modulo ? { modulo } : {}), ...(prueba ? { prueba: 1 } : {}) } }).then((r) => r.data);
export const getBossModulos = (courseId) => api.get(`/boss/${courseId}/modulos`).then((r) => r.data);
export const bossVictory = (courseId, modulo) =>
  api.post(`/boss/${courseId}/victory`, null, { params: modulo ? { modulo } : {} }).then((r) => r.data);
